export default __webpack_public_path__ + "static/media/yosemite-slab.e8901302.jpg";